import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { UserService, AlertService } from '@app/_services';
import { ReservationService } from '@app/_components/reservation';

@Injectable({
    providedIn: 'root'
})

@Injectable()
export class ReservationResolver  {

    constructor(
        private reservationService: ReservationService
    )
    { }

    resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
    {
        return this.reservationService.findById(+activatedRouteSnapshot.paramMap.get('reservationId'));
    }
}
